import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, lifecycle, withState } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableBody } from '@material-ui/core';
import ImagePreview from '../../components/molecules/ImagePreview';
import usageTypes from '../../constants/UsageType';
import CancelButton from '../../components/atoms/CancelButton';
import SubmitButton from '../../components/atoms/SubmitButton';

const styles = {
  root: {
    // position: 'absolute',
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    top: '5%',
    // left: '2%',
    backgroundColor: '#fff',
    padding: 20,
    overflow: 'auto',
    outline: 'none',
    borderRadius: 4,
    paddingBottom: 10,
    color: '#000000'
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: 0,
    boxShadow: 'none',
    color: '#000000'
  },
  description: {
    color: '#707070',
    margin: '20px 0px 0px'
  },
  detailTable: {
    width: '100%'
  },
  tableCellItem: {
    borderBottom: '1px solid #DDDDDD',
    borderTop: '1px solid #DDDDDD',
    backgroundColor: '#F7F7F7',
    fontSize: 12,
    fontWeight: 'bold',
    padding: 10,
    // whiteSpace: 'nowrap',
    width: 100
  },
  tableCellData: {
    borderTop: '1px solid #DDDDDD',
    borderBottom: '1px solid #DDDDDD',
    padding: '12px 10px',
    fontSize: 12,
    whiteSpace: 'pre-line'
  },
  titleDetail: {
    margin: '20px 0px 24px',
    textAlign: 'left',
    backgroundColor: '#fff',
    fontSize: 24,
    fontWeight: 700,
    color: '#000000'
  },
  btnBox: {
    margin: '48px 0 30px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    name: state.loginInfo.name,
    taxTypes: state.gochiMenus.taxTypes
  })),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  setPropTypes(propTypes),
  lifecycle({
    componentDidMount() {
      this.props.setIsLanguage(this.props.currentLanguage);
    }
  })
);

const Main = enhance(
  ({
    classes,
    backAction,
    registerAction,
    addConfirm,
    shopName,
    taxTypes,
    reducedTaxMenuPrefix,
    menuGenreName,
    getUsageTypeName
  }) => {
    const USAGE_TYPE_MENU = usageTypes[0].id;
    const USAGE_TYPE_VOUCHER = usageTypes[1].id;
    const USAGE_TYPE_COMBO = usageTypes[2].id;

    return (
      <div className={classes.root}>
        <Typography className={classes.titleDetail}>
          メニュー追加の確認
        </Typography>
        <Paper className={classes.mainPaper} elevation={1}>
          <Table className={classes.detailTable}>
            <TableBody>
              <TableRow>
                <TableCell className={classes.tableCellItem}>用途</TableCell>
                <TableCell className={classes.tableCellData}>
                  {getUsageTypeName(addConfirm.usageType)}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>店舗名</TableCell>
                <TableCell className={classes.tableCellData}>
                  {shopName}
                </TableCell>
              </TableRow>
              {addConfirm.usageType === USAGE_TYPE_MENU && (
                <>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      メニュー名
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {(() => {
                        if (addConfirm.reducedTaxType === 'REDUCED') {
                          return reducedTaxMenuPrefix;
                        }
                        return '';
                      })()}
                      {addConfirm.menuName}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      メニュー画像
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      <ImagePreview previewImage={addConfirm.previewImage} />
                    </TableCell>
                  </TableRow>
                </>
              )}
              {addConfirm.usageType !== USAGE_TYPE_COMBO ? (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>価格</TableCell>
                  <TableCell className={classes.tableCellData}>
                    {parseInt(addConfirm.price, 10).toLocaleString()}
                    {`円`}
                  </TableCell>
                </TableRow>
              ) : (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    単価×発行枚数
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {`${parseInt(
                      addConfirm.priceCombo,
                      10
                    ).toLocaleString()}円ｘ${addConfirm.quantity}枚`}
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell className={classes.tableCellItem}>税区分</TableCell>
                <TableCell className={classes.tableCellData}>
                  {addConfirm.taxType &&
                  addConfirm.taxType.toString() === 'DONATION'
                    ? taxTypes.map(item => {
                        if (item.id.toString() === 'INTERNAL') {
                          return item.name;
                        }
                        return '';
                      })
                    : taxTypes.map(item => {
                        if (
                          addConfirm.taxType &&
                          addConfirm.taxType.toString() === item.id.toString()
                        ) {
                          return item.name;
                        }
                        return '';
                      })}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  軽減税率対象
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {addConfirm.reducedTaxCheck}
                  {(() => {
                    if (addConfirm.reducedTaxType === 'REDUCED') {
                      return '対象内';
                    }
                    return '対象外';
                  })()}
                </TableCell>
              </TableRow>
              {addConfirm.usageType === USAGE_TYPE_COMBO && (
                <>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      付与無料枚数
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {addConfirm.quantityFree
                        ? `${addConfirm.quantityFree}枚`
                        : ''}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      おまけ
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {addConfirm.quantityFreeDes}
                    </TableCell>
                  </TableRow>
                </>
              )}
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  ジャンル
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {menuGenreName}
                </TableCell>
              </TableRow>
              {addConfirm.usageType === USAGE_TYPE_MENU && (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>説明</TableCell>
                  <TableCell className={classes.tableCellData}>
                    {addConfirm.description}
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell className={classes.tableCellItem}>タグ</TableCell>
                <TableCell className={classes.tableCellData}>
                  {addConfirm.tagStr}
                </TableCell>
              </TableRow>
              {addConfirm.usageType !== USAGE_TYPE_MENU && (
                <>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      メニュー名
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {(() => {
                        if (addConfirm.reducedTaxType === 'REDUCED') {
                          return reducedTaxMenuPrefix;
                        }
                        return '';
                      })()}
                      {addConfirm.menuName}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      メニュー画像
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      <ImagePreview previewImage={addConfirm.previewImage} />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      説明
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {addConfirm.description}
                    </TableCell>
                  </TableRow>
                </>
              )}
              {addConfirm.usageType === USAGE_TYPE_COMBO && (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    利用制限
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {addConfirm.numberUsePerDay === 0 ? 'なし' : '1日1枚'}
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  利用期間
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {addConfirm.expiration && addConfirm.expiration !== ''
                    ? `${addConfirm.expiration}日間`
                    : addConfirm.expirationEndDate}
                </TableCell>
              </TableRow>
              {addConfirm.usageType === USAGE_TYPE_VOUCHER && (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    利用方法
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {addConfirm.menuLimitTotal === 1
                      ? '一円単位利用'
                      : '一枚単位利用'}
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  寄付設定
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {addConfirm.taxType === 'DONATION' ? '対象内' : '対象外'}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Paper>
        <div className={classes.btnBox}>
          <CancelButton onClickAction={backAction} color="primary" />
          <SubmitButton onClickAction={registerAction} btnText="追加" />
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
